import { state } from 'cerebral'
import * as sequences from './sequences'
import apiClient from '../../lib/util/api-client'
import schemaSettings from '../../../shared/schemas/status-update-schema'
import { createProviders } from '../providers'
import { redirectUnauthorized, createCrudState } from '../factories'
import { showFeedbackFromError } from '../feedback/factories'

const { statusUpdateSchema: schema } = schemaSettings
const service = apiClient.service('status-updates')

export default ({ name }) => ({
  state: {
    ...createCrudState({ entityType: 'statusUpdates', storePrefix: name }),
    dashboard: {
      selectedFilter: 'all',
      startDate: null,
      endDate: null,
    },
  },
  sequences,
  providers: createProviders({ name, service, schema }),
  catch: [
    redirectUnauthorized(),
    [
      Error,
      showFeedbackFromError({ title: 'We encountered an error' }),
      ({ props: { error, errorPath = name }, store }) => {
        store.set(state`errors.${errorPath}`, error)
      },
    ],
  ],
})
